import { pathObj } from "../../services/apiPath";
import { apiDelete, apiGet, apiPost, apiPut } from "../../services/httpServices";

const addInterestMatrimonialDataApi = async (payload, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiPost(
      pathObj.ADD_INTEREST_MATRIMONIAL,
      payload
    );
    if (response?.data?.success) {
      notification.success(response?.data?.message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(response.data.message);
      console.error("Something went wrong");
    }
  } catch (error) {
    callback?.(false, true);
    console.error(error);
  }
};

const getInterestMatrimonialApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.INTEREST_MATRIMONIAL_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

export { addInterestMatrimonialDataApi, getInterestMatrimonialApi };
